import moment from 'moment-timezone';

/**
 * Get page limit from user context based on module type
 * @param {boolean} isLeadSpecific - Whether it's from leads module
 * @param {boolean} isFromCaseSpecificModule - Whether it's from case module
 * @param {Object} userContext - User context object
 * @returns {number|undefined} - Page limit or undefined
 */
export const getPageLimit = (isLeadSpecific, isFromCaseSpecificModule, userContext) => {
  if (isLeadSpecific && userContext) {
    return userContext?.firmDetails?.pagination_preference?.leads?.billings?.temp_fund_list;
  } else if (isFromCaseSpecificModule && userContext) {
    return userContext?.firmDetails?.pagination_preference?.case?.temp_fund_list;
  } else if (userContext) {
    return userContext?.firmDetails?.pagination_preference?.billings?.temp_fund_list;
  }
};

/**
 * Get file path for pagination preferences
 * @param {boolean} isLeadSpecific - Whether it's from leads module
 * @param {boolean} isFromCaseSpecificModule - Whether it's from case module
 * @returns {Object} - Path object with module, subModule, and listName
 */
export const getFilePathForPagination = (isLeadSpecific, isFromCaseSpecificModule) => {
  if (isLeadSpecific) {
    return { module: 'leads', subModule: 'billings', listName: 'temp_fund_list' };
  } else if (isFromCaseSpecificModule) {
    return { module: 'case', subModule: 'billings', listName: 'temp_fund_list' };
  } else {
    return { module: 'billings', subModule: '', listName: 'temp_fund_list' };
  }
};

/**
 * Extract date range from date array
 * TimezoneDatePicker already returns ISO strings with correct start/end of day times
 * First element has start of day (00:00:00), second element has end of day (23:59:59)
 * @param {Array} dateArray - Array of ISO string dates [startDate, endDate] from TimezoneDatePicker
 * @param {string} timezone - User timezone (used for single date selection handling)
 * @returns {Object} - Object with transaction_date_lower and transaction_date_upper
 */
export const pickExtractedDate = (dateArray, timezone) => {
  const lowerDate = dateArray?.[0] || '';
  let upperDate = dateArray?.[1] || '';

  // If only one date is selected (upper is null/empty), create end-of-day version for upper bound
  if (lowerDate && !upperDate) {
    const parsed = moment(lowerDate).tz(timezone);
    upperDate = moment
      .tz(
        {
          year: parsed.year(),
          month: parsed.month(),
          date: parsed.date(),
          hour: 23,
          minute: 59,
          second: 59,
        },
        timezone
      )
      .format();
  }

  return {
    transaction_date_lower: lowerDate,
    transaction_date_upper: upperDate,
  };
};

export const showFormErrorMessage = (name, errors) => {
  return name && errors[name] ? <small className="p-error">{errors[name]?.message}</small> : null;
};
